"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateEmailNotDisposable = void 0;
const errors_1 = require("../errors");
const disposable_email_domains_1 = require("./disposable-email-domains");
/**
 * Checks if an email address uses a disposable/temporary email domain
 * @param email - The email address to check
 * @returns true if the email domain is in the disposable domains list
 */
const isDisposableEmail = (email) => {
    const emailDomain = email.split("@")[1];
    return disposable_email_domains_1.disposableDomains.includes(emailDomain);
};
/**
 * Validates that an email address is not using a disposable domain
 * @param email - The email address to validate
 * @throws {ClientError} When the email uses a disposable domain
 */
const validateEmailNotDisposable = (email) => {
    if (isDisposableEmail(email)) {
        throw new errors_1.ClientError("Email address not allowed.");
    }
};
exports.validateEmailNotDisposable = validateEmailNotDisposable;
//# sourceMappingURL=email-validation.js.map